/**
 * The lines of a build's output that list the binaries it made and their
 * sizes: esptool's `Generated <file>.bin` and the `binary size` line of
 * ESP-IDF's check_sizes.py. The bootloader's lines come last, since the order
 * in which ninja printed the app and the bootloader sub-build varies.
 */
export function binaryReports(output: string): string[] {
    const lines = output
        .split("\n")
        .map((line) => line.trimEnd())
        .filter((line) => GENERATED.test(line) || SIZE.test(line));
    const bootloader = (line: string) => BOOTLOADER.test(line);
    return [...lines.filter((line) => !bootloader(line)), ...lines.filter(bootloader)];
}

const GENERATED = /^Generated \S+\.bin$/;
const SIZE = /\bbinary size 0x[0-9a-f]+ bytes\b/i;
const BOOTLOADER = /^(Generated \S*\/bootloader\/bootloader\.bin|Bootloader binary size )/;
